import { render, staticRenderFns } from "./StudentInquiryOn.vue?vue&type=template&id=8555f2ec&scoped=true"
import script from "./StudentInquiryOn.vue?vue&type=script&lang=js"
export * from "./StudentInquiryOn.vue?vue&type=script&lang=js"
import style0 from "./StudentInquiryOn.vue?vue&type=style&index=0&id=8555f2ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8555f2ec",
  null
  
)

export default component.exports